import { ShowroomService } from '@/services';
import { PaginationType, RootModel, ShowroomType } from '@/types';
import { createModel } from '@rematch/core';
import baseEntity from './base.entity';

interface ShowroomStateType {
  ids: { [id: number]: ShowroomType };
}

export const showroomEntities = createModel<RootModel>()({
  state: { ids: {} } as ShowroomStateType,
  reducers: {
    ...baseEntity,
  },
  effects: () => ({
    async load(payload): Promise<{ content: ShowroomType[] } & PaginationType> {
      const res = await ShowroomService.filter(payload);
      const { content } = res.data;
      if (content && content.length) {
        this.saveSimplified(content);
      }
      return res.data;
    },
    async findById(payload, state: any): Promise<ShowroomType> {
      const item = state.showroomEntities.ids[payload];
      if (item && !item.simplified) {
        return item;
      }
      const res = await ShowroomService.getById(payload);
      this.saves([res.data]);
      return res.data;
    },
    async delete(payload) {
      await ShowroomService.deleteById(payload);
      this.remove({ id: payload });
    },
    async save(payload) {
      let item;
      if (!payload.id) {
        ({ data: item } = await ShowroomService.create(payload));
      } else {
        ({ data: item } = await ShowroomService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    },
    async publish(payload) {
      const { data } = await ShowroomService.publish(payload);
      this.update(data);
      return data;
    },
    async mapVisualizations(payload) {
      const { data } = await ShowroomService.mapVisualizations(payload);
      this.update(data);
      return data;
    },
    async mapProducts(payload) {
      const { data } = await ShowroomService.mapProducts(payload);
      this.update(data);
      return data;
    },
    async updateDefaultShowroom(payload) {
      const { data } = await ShowroomService.updateDefaultShowroom(payload);
      this.update(data);
      return data;
    },
  }),
});
